import { Pipe, PipeTransform } from '@angular/core';
import { PersianService } from '../services/persian.service';

@Pipe({
  name: 'persianNumber'
})
export class PersianNumberPipe implements PipeTransform {
  constructor(private persianService: PersianService) {}

  transform(value: any): string {
    if (value === undefined || value === null) {
      return '';
    }
    return this.persianService.toPersianNumber(value.toString());
  }
  Englishtransform(value: any): string {
    if (value === undefined || value === null) {
      return '';
    }
    return this.persianService.toEnglishNumber(value.toString()).toString();
  }
}
